import { groupReducer } from './groupReducer';
import { productionStepsReducer } from './productionStepsReducer';
import { productionStepsStatsReducer } from './productionStepsStatsReducer';
import { combineReducers } from 'redux';
import { usersReducer } from './usersReducer';
import activeUserReducer from './activeUserReducer';
import { modelListReducer } from './modelListReducer';
import { activeModelReducer } from './activeModelReducer';
import { reducer } from '@react-page/editor/lib/core/reducer';
import { activeObjectReducer } from './activeObjectReducer';
import { viewsReducer } from './viewsReducer';
import { activeStateReducer } from './activeStateReducer';
import { activeViewReducer } from './activeViewReducer';
import { auditReducer } from './auditReducer';
import { revisionsReducer } from './revisionsReducer';
import { projectsReducer } from './projectReducer';
import { settingsReducer } from './settingsReducer';
import { templateLayoutsReducer } from './templateLayoutsReducer';
import { customReactPageReducer } from './customReactPageReducer';
import editableTablesReducer from './editableTableReducer';
import { commentsReducer } from './commentsReducer';

const rootReducer = combineReducers({
	// combines all pieces of state with their reducers
	reactPage: reducer,
	groups: groupReducer,
	productionSteps: productionStepsReducer,
	productionStepsStats: productionStepsStatsReducer,
	users: usersReducer,
	activeUser: activeUserReducer,
	modelList: modelListReducer,
	activeModel: activeModelReducer,
	activeObject: activeObjectReducer,
	activeState: activeStateReducer,
	views: viewsReducer,
	activeView: activeViewReducer,
	audit: auditReducer,
	revisions: revisionsReducer,
	projects: projectsReducer,
	settings: settingsReducer,
	templateLayouts: templateLayoutsReducer,
	customReactPage: customReactPageReducer,
	editableTables: editableTablesReducer,
	comments: commentsReducer,
});

export default rootReducer;
